module.exports = __webpack_public_path__ + "static/media/red-bg.b3477885.png";